import { PropsWithChildren } from 'react'
import { useCurrentUserType, UserType } from '@/hooks'
import useAuthStore from '@/stores/useAuthStore/useAuthStore'

type RoleRestrictedContentProps = PropsWithChildren & {
    allowedRoles: UserType[]
    strict?: boolean
}

export const RoleRestrictedContent: React.FC<RoleRestrictedContentProps> = ({
    allowedRoles,
    strict = true,
    children,
}) => {
    const userType = useCurrentUserType()
    const hasCustomer = useAuthStore((state) => !!state.customer)

    if (!userType) {
        return null
    }

    // Check if the user is impersonating a customer
    const isImpersonatingCustomer =
        userType !== UserType.CUSTOMER && hasCustomer

    // Prioritize actual user role over impersonated role
    if (allowedRoles.includes(userType)) {
        // If strict is true, disallow impersonation access
        if (
            !allowedRoles.includes(UserType.CUSTOMER) &&
            isImpersonatingCustomer &&
            strict
        ) {
            return null
        }
        return children
    }

    // Handle impersonation for customer role
    if (
        isImpersonatingCustomer &&
        !strict &&
        allowedRoles.includes(UserType.CUSTOMER)
    ) {
        return children
    }

    return null
}
